// Styles
import FairValueChartsViewContainer from "./FairValueChartsView.styles";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useBQMQ } from "context/BQMQ.context";

type Props = {};

export default function FairValueChartsView({}: Props) {
    const location = useLocation();
    const { companies } = useBQMQ();

    const companyId = useMemo(() => {
        return new URLSearchParams(location.search).get("company_id");
    }, [location.search]);

    const company = useMemo(() => {
        if (!companyId) return null;
        return (
            companies.find(
                (c: BQMQDropdownCompany) => String(c.value) === companyId
            ) ?? null
        );
    }, [companyId, companies]);

    const filterString = company
        ? `dim_full_snapshot_companies_list/bbg_company_name eq '${company.label}'`
        : undefined;

    return (
        <FairValueChartsViewContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="3814b586-6386-4a51-a763-332b3b9b8ba8"
                    workspaceId="ba0ccfe6-4d32-44b6-aca5-e2ac72312904"
                    filterString={filterString}
                />
            </div>
        </FairValueChartsViewContainer>
    );
}
